import React from 'react';
import PropTypes from 'prop-types';

import { xpackType } from 'types';

import XpackItem from './components/XpackItem';
import XpackSort from './components/XpackSort';

import './style.scss';

const XpacksList = ({
  xpacks,
  selectedSortOption,
  isDownloading,
  getXpacks,
  onUpdate,
  onDelete,
  onDownload,
  onOverrideAllXpackIntents,
  overrideAllXpackIntentsIsLoading,
  onDisableAllXpackIntents,
  disableAllXpackIntentsIsLoading,
}) => (
  <React.Fragment>
    <XpackSort getXpacks={getXpacks} selectedSortOption={selectedSortOption} />

    <ul data-test="xpacks-list" styleName="list">
      {xpacks.map(item => (
        <XpackItem
          key={item.id}
          deleteXpack={onDelete}
          disableAllXpackIntentsIsLoading={disableAllXpackIntentsIsLoading}
          downloadXpack={onDownload}
          isDownloading={isDownloading}
          overrideAllXpackIntentsIsLoading={overrideAllXpackIntentsIsLoading}
          updateXpack={onUpdate}
          xpack={item}
          onDisableAllXpackIntents={onDisableAllXpackIntents}
          onOverrideAllXpackIntents={onOverrideAllXpackIntents}
        />
      ))}
    </ul>
  </React.Fragment>
);

XpacksList.propTypes = {
  disableAllXpackIntentsIsLoading: PropTypes.bool.isRequired,
  overrideAllXpackIntentsIsLoading: PropTypes.bool.isRequired,
  onDisableAllXpackIntents: PropTypes.func.isRequired,
  onOverrideAllXpackIntents: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  getXpacks: PropTypes.func,
  isDownloading: PropTypes.bool,
  selectedSortOption: PropTypes.string,
  xpacks: PropTypes.arrayOf(xpackType),
  onDelete: PropTypes.func,
  onDownload: PropTypes.func,
};

export default XpacksList;
